<script setup>
import { ref, inject } from 'vue'
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getPayOrderStatus } from 'model/campaign'

import Airwallex from './components/Airwallex/Airwallex.vue';

const refList = {
  AIRWALLEX: 'AirwallexRef'
}

const router = useRouter()
const route = useRoute()
const store = useStore()

const AirwallexRef = ref(null)

const show = ref(false)

const payType = ref('')
const bindData = ref({})
const orderId = ref('')

const completeWait = ref(false)

const open = (type, data, id) => {
  console.log(type, data)
  payType.value = type
  bindData.value = data
  orderId.value = id
  show.value = true
}
const close = () => {
  show.value = false
  AirwallexRef.value.closeDestory()
  completeWait.value = false
  bindData.value = {}
  payType.value = ''
}

const ProvideIsJump = inject('ProvideIsJump')

const handleSuccess = () => {
  // 销毁前注销元素
  AirwallexRef.value?.closeDestory()
  completeWait.value = true
  const successInterval = setInterval(async () => {
    const isCompleted = await checkCompleted()
    if (isCompleted || !show.value) {
      clearInterval(successInterval)
    }
  }, 1000)
}

const checkCompleted = async () => {
  if (!orderId.value) {
    return false
  }
  const res = await getPayOrderStatus({
    orderId: orderId.value,
  })
  if (res && res.boolRet === true) {
    const id = orderId.value
    orderId.value = ''
    await store.dispatch('user/getBalance')
    completeWait.value = true
    onPayCompleted(id)
    return true
  }
  return false
}

const onPayCompleted = (id) => {
  if (ProvideIsJump && !route.path === '/wap/campaign') {
    this.$router.push('/my/orders')
  } else if (route.path === '/wap/campaign') {
    if (route.query.serviceType === 'ASO_SERVICE') {
      return
    }
    router.push('/wap/order')
  } else {
    router.push({
      name: 'Transactions',
      params: {
        rechargeOrderId: id
      }
    })
  }
}

defineExpose({
  open
})
</script>
<template>
  <div class="embed">
    <van-dialog
      v-model:show="show"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :close-on-click-overlay="true"
      @close="close"
    >
      <Airwallex v-if="payType === 'AIRWALLEX'" ref="AirwallexRef" v-bind="bindData" @completed="handleSuccess" />
      <div v-if="completeWait" class="vant-content pl-15 pr-15 mt-10 mb-10 text-main text-sm">
        <div class="flex justify-center"><van-loading color="#0094ff" /></div>
        <div class="mt-10">Wait for a moment while we are confirming your payment result.</div>
      </div>
    </van-dialog>
  </div>
</template>
<style lang="scss" scoped>
.embed {
    :deep(.van-dialog) {
        padding: 20px;
    }
}
</style>